import React from "react";
import styles from "./DownloadProgress.module.css";
import { t } from "../../utils/i18n";
import { APP_APK_FILENAME } from "../../utils/downloadFile";

const ProgressBar = ({ percent }) => {
  const hasPercent = typeof percent === "number";
  const showIndeterminate = !hasPercent;

  return (
    <div className={styles.barTrack}>
      {showIndeterminate ? (
        <div
          className={`${styles.barFill} ${styles.barFillIndeterminate}`}
        />
      ) : (
        <div
          className={styles.barFill}
          style={{ width: `${Math.max(0, Math.min(100, percent))}%` }}
        />
      )}
    </div>
  );
};

const DownloadProgress = ({
  open,
  minimized = false,
  phase = "preparing",
  percent = null,
  onMinimize,
  onExpand,
}) => {
  if (!open) return null;

  const isDownloading = phase === "downloading";
  const hasPercent = typeof percent === "number";

  const message = isDownloading
    ? hasPercent
      ? t("home.download.downloadingPercent", "Downloading {percent}%...", {
          percent,
        })
      : t("home.download.downloading", "Downloading...")
    : t("home.download.preparing", "Preparing download...");

  if (minimized) {
    return (
      <button
        type="button"
        className={styles.minimized}
        onClick={onExpand}
        aria-label={t(
          "home.download.expand",
          "Show download progress",
        )}
      >
        <span className={styles.minimizedTitle}>
          {t("home.download.title", "Downloading Gamee App")}
        </span>
        <span className={styles.minimizedMessage}>{message}</span>
        <ProgressBar percent={percent} />
        {hasPercent ? (
          <span className={styles.minimizedPercent}>{percent}%</span>
        ) : null}
      </button>
    );
  }

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-busy="true"
      aria-label={t("home.download.title", "Downloading Gamee App")}
    >
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h3 className={styles.title}>
            {t("home.download.title", "Downloading Gamee App")}
          </h3>
          <button
            type="button"
            className={styles.minimizeBtn}
            onClick={onMinimize}
            aria-label={t("home.download.minimize", "Minimize")}
          >
            <span aria-hidden="true">—</span>
          </button>
        </div>
        <p className={styles.message}>{message}</p>
        <ProgressBar percent={percent} />
        {hasPercent ? (
          <span className={styles.percent}>{percent}%</span>
        ) : null}
        <p className={styles.hint}>
          {t(
            "home.download.hint",
            "Please wait. The file will be saved as {filename}.",
            { filename: APP_APK_FILENAME },
          )}
        </p>
      </div>
    </div>
  );
};

export default DownloadProgress;
